import * as React from "react";

export const Stop = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.10942 8C3.10942 5.29897 5.29904 3.10935 8.00008 3.10935C9.13428 3.10935 10.1783 3.49544 11.0079 4.14336L4.14344 11.0078C3.49551 10.1782 3.10942 9.1342 3.10942 8ZM4.99193 11.8564C5.82157 12.5045 6.86572 12.8907 8.00008 12.8907C10.7011 12.8907 12.8907 10.701 12.8907 8C12.8907 6.86565 12.5045 5.8215 11.8565 4.99185L4.99193 11.8564ZM8.00008 1.90935C4.6363 1.90935 1.90942 4.63622 1.90942 8C1.90942 11.3638 4.6363 14.0907 8.00008 14.0907C11.3639 14.0907 14.0907 11.3638 14.0907 8C14.0907 4.63622 11.3639 1.90935 8.00008 1.90935Z"
    />
);
